import * as React from "react"
import {AmchartSeeker} from "@ui-seeker/core";

import {kpiPrice} from "@signals";
import {KPI_PRICING} from "@constants";
import { CHART_PRICE_STOCK_EVOLUTION_COLORS, CHART_PRICE_STOCK_STATUS_COLOR } from "Pages/Pricing/constants";


const _series = [{
    key: 'myPrice', name: 'My Price'
}, {
    key: 'avgPrice', name: 'Avg Price'
}, {
    key: 'bestPrice', name: 'Best Price'
}]

export default function PricingSkuEvolutionChart({ isViewTopRetailersData, data, currentFiveRetailers, currency }) {

    const series = isViewTopRetailersData ? currentFiveRetailers : _series

    return <AmchartSeeker
        rootID="SkuEvolution"
        hiddenCard
        data={data}
        series={series.map(({ key, name }) => ({
            name, yField: kpiPrice.value === KPI_PRICING.ACTUAL ? key : `${key}List`,
            xField: "date",
            connect: true,
            ...( key.includes('Main Site)') ) && {
                strokes: {
                    strokeDasharray: [8, 8]
                }
            },
            ...(isViewTopRetailersData) && {bullets: {
                adapters: {
                    color: (fill, target) => {
                        return target.dataItem.dataContext[`${key}Stock`] ? CHART_PRICE_STOCK_STATUS_COLOR.IN_STOCK : CHART_PRICE_STOCK_STATUS_COLOR.OUT_OF_STOCK
                    }
                }
                
            }}, 
            ...(isViewTopRetailersData) && {tooltip: {
                labelText: `{name}:{valueY}[/] - {${key}StockLabel} `
            }}
        }))}
        chartProps={{
            root: {
                colors: CHART_PRICE_STOCK_EVOLUTION_COLORS
            },
            enabledPDF: false,
            numberFormat: `#,###.00 ' ${currency}'`,
            xAxis: {
                categoryField: 'date',
                isDateAxis: true,
                title: 'Dates'
            },
            yAxis: {
                title: 'Price'
            }
        }}
    />
}